import N8nMarkdown from './Markdown.vue';

export default N8nMarkdown;
